export const GET_USERS_TOPIC_ACCESS_START = 'GET_USERS_TOPIC_ACCESS_START';
export const GET_USERS_TOPIC_ACCESS_SUCCESS = 'GET_USERS_TOPIC_ACCESS_SUCCESS';
export const GET_USERS_TOPIC_ACCESS_FAIL = 'GET_USERS_TOPIC_ACCESS_FAIL';

export const POST_REC_TOPIC_ACCESS_START = 'POST_REC_TOPIC_ACCESS_START';
export const POST_REC_TOPIC_ACCESS_SUCCESS = 'POST_REC_TOPIC_ACCESS_SUCCESS';
export const POST_REC_TOPIC_ACCESS_FAIL = 'POST_REC_TOPIC_ACCESS_FAIL';
